import { render, staticRenderFns } from "./FilterPlacementsForm.tmplacements.vue?vue&type=template&id=da397af6&scoped=true&lang=html&"
import script from "./FilterPlacementsForm.tmplacements.vue?vue&type=script&lang=js&"
export * from "./FilterPlacementsForm.tmplacements.vue?vue&type=script&lang=js&"
import style0 from "./FilterPlacementsForm.tmplacements.vue?vue&type=style&index=0&id=da397af6&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da397af6",
  null
  
)

export default component.exports